import {TextColumn, TextColumnConfig} from './text-column.model';

export class UuIdColumn extends TextColumn {
  array: any[];
  displayProperty: string;

  constructor(title: string,
              config: UuIdColumnConfig) {
    super(title,
      {
        property: config.property,
        limit: config.limit
      });
    this._columnType = 'UuIdColumn';
    this.displayProperty = config.displayProperty;
  }

  get(element: any): any {
    if (!this.array) {
      return null;
    }

    const res = this.array.find(elem => elem['uuId'] === element[this.property]);

    if (!res) {
      return null;
    }

    return res[this.displayProperty];
  }
}

export interface UuIdColumnConfig extends TextColumnConfig {
  displayProperty: string;
}
